import { IkasBaseModel } from "../base";
import { IkasHTMLMetaDataTranslations } from "./translations";

export type IkasHTMLMetaData = {
  canonicals?: string[] | null;
  description?: string | null;
  disableIndex?: boolean | null;
  pageTitle?: string | null;
  slug: string;
  targetId?: string | null;
  targetType?: IkasHTMLMetaDataTargetType | null;
  translations?: IkasHTMLMetaDataTranslations[] | null;
} & IkasBaseModel;

export type IkasHTMLMetaDataOverride = {
  description: string;
  language: string | null;
  pageTitle: string;
  storefrontId: string | null;
  storefrontRegionId: string | null;
};

export enum IkasHTMLMetaDataTargetType {
  BRAND = "BRAND",
  CATEGORY = "CATEGORY",
  PAGE = "PAGE",
  PRODUCT = "PRODUCT",
}
